import { useEffect, useState } from 'react';
import { PaymentRailsApi } from '@/api/clients/payment-rails/payment-rails.api';

let cachedCatalog = null;
let inflight = null;

export const useGetPaymentRailCatalog = () => {
  const [catalog, setCatalog] = useState(cachedCatalog || []);
  const [loading, setLoading] = useState(!cachedCatalog);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (cachedCatalog) {
      setCatalog(cachedCatalog);
      setLoading(false);
      return;
    }
    if (!inflight) {
      inflight = (async () => {
        try {
          const res = await PaymentRailsApi.getCatalog();
          cachedCatalog = res.data?.data || [];
          return cachedCatalog;
        } catch (err) {
          inflight = null;
          throw err;
        }
      })();
    }
    let cancelled = false;
    (async () => {
      try {
        const data = await inflight;
        if (cancelled) return;
        setCatalog(data);
      } catch (err) {
        if (cancelled) return;
        setError(err);
        console.error('Failed to load payment rail catalog:', err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { catalog, loading, error };
};

export const findCatalogEntry = (catalog, method, subType) =>
  catalog.find(
    (entry) =>
      entry.method === method &&
      (entry.subTypes.length === 0
        ? subType == null
        : entry.subTypes.includes(subType)),
  );

export const getPaymentRailDisplayName = (catalog, method, subType) => {
  const entry = findCatalogEntry(catalog, method, subType);
  if (!entry) return `#${method}${subType ? `/${subType}` : ''}`;
  if (entry.subTypes.length === 0) return entry.name;
  return `${entry.name} (${subType})`;
};

export const expandCatalogOptions = (catalog) => {
  const options = [];
  catalog.forEach((entry) => {
    if (entry.subTypes.length === 0) {
      options.push({
        key: `${entry.method}`,
        method: entry.method,
        subType: null,
        label: entry.name,
        workflows: entry.workflows,
      });
    } else {
      entry.subTypes.forEach((subType) => {
        options.push({
          key: `${entry.method}-${subType}`,
          method: entry.method,
          subType,
          label: `${entry.name} (${subType})`,
          workflows: entry.workflows,
        });
      });
    }
  });
  return options;
};
